import { Outlet } from "react-router-dom";

import { useUser } from "~/api/users/retrieve";
import useAmplitude from "~/hooks/useAmplitude";
import useAuth from "~/hooks/useAuth";
import { LoadingPage } from "~/theme/components";

function Layout() {
  const auth = useAuth();
  const { data } = useUser();

  useAmplitude({ id: data?.id });

  return (
    <>
      <LoadingPage />
      <Outlet context={{ auth, user: data }} />
    </>
  );
}

export default Layout;
